export enum FrageKognitiveProbleme {
  KEINE = 'keine',

  GELEGENTLICH = 'gelegentlich',

  MASSIVE = 'massive',
}
